/**
 * file : Ranking/Prize.jsx
 * 설명 : 상금별 랭킹
 */

import { Fnc } from "common/globals";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import { Search } from "components/Common/ApiCall";

export default function Prize( props ) {
  // 접속자 토큰 정보
  const { token } = useSelector(state => state.Client);
  // 토큰 정보 추출
  const info = Fnc.TokenSubstitution(token.access_token);
  // 데이터
  const [datas, setDatas] = useState();
  // 기존 데이터
  const [original, setOriginal] = useState();
  // 리스트 갯수
  const [listCount, setListCount] = useState(5)
  const showMore = () => {
    let count = listCount > datas.length ? datas.length : listCount + 5
    setListCount(count);
  }
  // 나의 순위 보기
  const MyRanking = (e) => {
    if (e.target.checked) {
      const newData = datas.filter((item) => item.user_idx === info.idx)
      setDatas(newData)
    } else {
      setDatas(original)
    }
  }
  // 조회
  useEffect(() => {
    Search('/ranking-prize-money', setDatas, props.setDataLoading, null, (result) => {
      setOriginal(result.result_data)
    });
  }, []);

  return (
    <div className="zeus-tab-item">
      <div className="search_box margin-bottom-10">
        <div className="check__ text-end" >
          <input id="prize" type="checkbox" onChange={MyRanking}/>
          <label htmlFor="prize"><span className="color-white">나의 순위 보기</span></label>
        </div>
      </div>
      <div className="table-container">
        <table className="table_style1">
          <thead>
            <tr>
              <th>랭킹</th>
              <th>회원 ID</th>
              <th>토너먼트 참여 횟수</th>
              <th>누적 상금 금액</th>
            </tr>
          </thead>
          <tbody>
            {
              !Fnc.Empty(datas) && datas.slice(0, listCount).map((data, index) => (
                <tr key={index}>
                  <td>{data.rank}위</td>
                  <td>
                    {data.user_id}
                    {data.user_idx === info.idx && <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -910 960 960" width="25px" fill="#0D7EE7"><path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" /></svg>}
                  </td>
                  <td>{data.tournament_cnt.toLocaleString()}</td>
                  <td className="align_r font_style1"><span className="won"></span>{data.settlement_amount.toLocaleString()}</td>
                </tr>
              ))
            }
          </tbody>
        </table>
        { Fnc.Empty(datas) && <div className='table-no-data'>내역이 존재하지 않아요</div> }
        {
          !Fnc.Empty(datas) &&
          listCount < datas.length && (
            <div className="btns_wrap mt_30 mb_30">
              <Link className="btn_more" onClick={showMore}>더불러오기</Link>
            </div>
          )
        }
      </div>
    </div>
  )
}